import { useState } from 'react'

import { Drawer } from '@loadsmart/miranda-react'

import { type StopAppointment } from 'core/appointments/domain/Appointment'

import { AppointmentCancelDialog } from './AppointmentCancelDialog'
import { StepContent } from './StepContent'

export type OpenDockAppointmentScheduledDrawerProps = {
  isOpen: boolean
  onClose: () => void
  appointment?: StopAppointment
}

export function OpenDockAppointmentScheduledDrawer({
  isOpen,
  onClose,
  appointment,
}: OpenDockAppointmentScheduledDrawerProps) {
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false)

  return (
    <>
      <Drawer open={isOpen} onClose={onClose}>
        <StepContent
          appointment={appointment}
          onCancelAppointment={() => setIsCancelDialogOpen(true)}
        />
      </Drawer>
      <AppointmentCancelDialog
        isOpen={isCancelDialogOpen}
        onClose={() => setIsCancelDialogOpen(false)}
        onConfirm={() => setIsCancelDialogOpen(false)}
      />
    </>
  )
}
